var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('BannerStatic',{staticStyle:{"height":"600px"},attrs:{"ban":_vm.banner}}),_c('School',{staticClass:"px-360",attrs:{"bg":_vm.background}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }